var map = {
	"./common": 422,
	"./common.js": 422,
	"./main": 658,
	"./main.js": 658,
	"./notification": 752,
	"./notification.js": 752,
	"./project/advants": 990,
	"./project/advants.js": 990,
	"./project/gallery": 43,
	"./project/gallery.js": 43,
	"./project/main-slider": 724,
	"./project/main-slider.js": 724
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 495;